import { initialStateByModule } from './state'
import { postQuotation } from '@/api/services'

const state = initialStateByModule('sendQuotation')

const SEND_QUOTATION_PENDING = 'sendQuotationPending'
const SEND_QUOTATION_SUCCESS = 'sendQuotationSuccess'
const SEND_QUOTATION_FAILURE = 'sendQuotationFailure'
const SET_SHIPPING_DETAILS = 'setShippingDetails'

const mutations = {
  [SEND_QUOTATION_PENDING] (state) {
    state.asyncPending = true
  },
  [SEND_QUOTATION_FAILURE] (state) {
    state.asyncPending = false
  },
  [SEND_QUOTATION_SUCCESS] (state, payload) {
    state.uuid = payload.data.uuid
    state.asyncPending = false
  },
  [SET_SHIPPING_DETAILS] (state, data) {
    state.shippingDetails = data
  }
}

const actions = {
  postQuotation ({ rootState, commit }, sendOption) {
    try {
      const payload = {
        distribuitionPartner: rootState.product.distribuitionPartner,
        operator: rootState.urlParams.operator,
        store: rootState.urlParams.store
      }

      payload.address = {
        city: rootState.address.city,
        complement: rootState.address.complement,
        neighborhood: rootState.address.neighborhood,
        state: rootState.address.state,
        streetName: rootState.address.streetName,
        streetNumber: rootState.address.streetNumber,
        zipcode: rootState.address.zipcode
      }

      payload.personalData = {
        birthday: rootState.personalData.birthday,
        cellphone: rootState.personalData.cellphone,
        checkEmail: rootState.personalData.email.email,
        cpf: rootState.personalData.cpf,
        email: rootState.personalData.email,
        name: rootState.personalData.name,
        gender: rootState.personalData.gender
      }

      payload.plan = {
        default: {
          completePrice: rootState.plan.default.completePrice
        },
        parcelasPrecos: rootState.plan.parcelasPrecos,
        precoTotal: rootState.plan.precoTotal,
        promo: {
          completePrice: 0
        },
        promoCode: {
          applied: false,
          code: null,
          error: null,
          enable: true
        },
        pontuacao: 0,
        uuid: rootState.plan.uuid,
        name: rootState.plan.name,
        preco: rootState.plan.preco,
        category: rootState.plan.category,
        type: rootState.plan.type,
        counterDependent: 0,
        listPersons: []
      }

      payload.sendQuotation = {
        firstName: rootState.personalData.name.split(' ').slice(0, 1).join(' '),
        type: sendOption,
        ...(sendOption && sendOption === 'email'
          ? { email: rootState.personalData.email }
          : { phone: rootState.personalData.cellphone }
        )
      }

      commit(SET_SHIPPING_DETAILS, payload.sendQuotation)

      return postQuotation(payload)
        .then(res => {
          commit(SEND_QUOTATION_SUCCESS, res)
          return res
        })
        .catch(error => {
          commit(SEND_QUOTATION_FAILURE, error)
          throw error
        })
    } catch (error) {
      commit(SEND_QUOTATION_FAILURE)
      this._vm.$sentry.logWithContext({
        level: 'error',
        tags: {
          app_product: rootState.product.alias,
          app_step: rootState.steps.currentStep,
          app_paymentMethod: rootState.payment.typePayment.method,
          app_errorZone: 'createQuotation'
        },
        ctx: {
          label: '[sendQuotation] - createQuotation'
        },
        error
      })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
